<template>
    <p class="sucesso_perguntas">{{pergunta}}</p>
    <p class="sucesso_respostas" v-html="resposta"></p>
</template>

<script>
export default {
  name: "HistoriaCasos",
  props:["pergunta","resposta"]
}
</script>

<style scoped>
.sucesso_perguntas {
  font-family: "Montserrat SemiBold",serif;
  color: #3f4244;
  font-size: 18px;
  padding-bottom: 10px;
  letter-spacing: 0.03px;
  padding-left: 15px;
}


.sucesso_respostas {
  font-family: 'Montserrat Light';
  color: #454648;
  padding-bottom: 40px;
  padding-left: 13px;
  line-height: 2.2;
  font-size: 16px;
  white-space: pre-wrap;
}

@media (min-width : 768px) and (max-width : 1024px) {
  .sucesso_perguntas {
    font-size: 16px;
    letter-spacing: 0.15px;
  }

  .sucesso_respostas {
    letter-spacing: 0;
    line-height: 1.9;
    padding-top: 0;
    padding-bottom: 30px;
    font-size: 15px;
    padding-bottom: 18px;
  }

  .sucesso_perguntas {
    padding-bottom: 0px;
    margin-bottom: 6px;
  }



}
@media (max-width: 767px) {

  .sucesso_perguntas {
    padding-right: 15px;
    padding-left: 15px;
    font-size: 15px;
    padding-bottom: 0;
  }
  .sucesso_respostas {
    color: #656565;
    line-height: 2;
    font-size: 14px;
    margin-top: 0;
    margin-bottom: 0;
    padding: 0 10px 40px 15px;
    font-size: 13px;
    padding: 0 0px 20px 0px;
  }

  .sucesso_perguntas {
    letter-spacing: 0px;
    font-size: 14px;
    margin-bottom: 3px;
    line-height: 1.4;
    padding-left: 0px;
    padding-right: 0px;
  }



}

</style>